import { render, staticRenderFns } from "./RevuesPleinSoleil.vue?vue&type=template&id=6fbb7841"
import script from "./RevuesPleinSoleil.vue?vue&type=script&lang=js"
export * from "./RevuesPleinSoleil.vue?vue&type=script&lang=js"
import style0 from "./RevuesPleinSoleil.vue?vue&type=style&index=0&id=6fbb7841&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports